import { create } from 'zustand';
import { DemoOrganization, GPUQuota, OrganizationQuota } from './types';
import { DEMO_ORGANIZATION_INITIAL_DATA } from './initialData';

type GPUType = 'h200' | 'a100' | 'l4';

type State = {
  organizations: DemoOrganization[];
  selectedOrgId: string | null;
};

type Action = {
  selectOrganization: (orgId: string) => void;
  updateOrganizationQuota: (orgId: string, gpuType: GPUType, quota: GPUQuota) => void;
  resetToInitial: () => void;
};

type DemoOrganizationStore = State & Action;

export const useDemoOrganizationStore = create<DemoOrganizationStore>()(
  (set) => ({
    organizations: DEMO_ORGANIZATION_INITIAL_DATA,
    selectedOrgId: null,

    selectOrganization: (orgId) =>
      set({
        selectedOrgId: orgId,
      }),

    updateOrganizationQuota: (orgId, gpuType, quota) =>
      set((state) => ({
        organizations: state.organizations.map((org) =>
          org.id === orgId
            ? {
                ...org,
                quota: {
                  ...org.quota,
                  [gpuType]: quota,
                },
              }
            : org
        ),
      })),

    resetToInitial: () =>
      set({
        organizations: DEMO_ORGANIZATION_INITIAL_DATA,
        selectedOrgId: null,
      }),
  })
);

// Export types for convenience
export type { DemoOrganization, GPUQuota, OrganizationQuota, GPUType };
